<template>
  <div
    class="express-checkout"
    v-if="!isAllEmpty"
  >
    <div class="express-checkout__header">
      <p class="express-checkout__title">
        Express Checkout Options
      </p>
      <p class="express-checkout__secure">
        <Icon
          class="express-checkout__icon"
          name="secure-l"
        />
        Secure Checkout
      </p>
    </div>
    <!-- Payment Skeleton -->
    <div
      class="express-checkout__content"
      v-if="loading"
    >
      <Skeleton height="40px" />
      <Skeleton
        :style="{ marginTop: '0' }"
        height="40px"
      />
    </div>
    <div
      class="express-checkout__content"
      v-else
    >
      <div
        class="express-checkout-paypal"
        :class="{
          'express-checkout-paypal--selected': paymentType === 0,
          'express-checkout-paypal--disabled': totalAmountAfterDiscount > 500
        }"
        @click="onPayPalClick"
      >
        <img
          class="express-checkout-paypal__logo"
          src="@/assets/illus/illus-paypal.svg"
        >
        <img
          src="@/assets/colorIcon/radio-selected.svg"
          v-if="paymentType === 0"
        >
        <Icon
          name="checkbox-unselect-f"
          v-else
        />
      </div>
      <div
        class="express-checkout-bank"
        :class="{
          'express-checkout-bank--selected': paymentType === 1
        }"
        @click="paymentType = 1"
      >
        <Icon
          class="express-checkout-bank__logo"
          name="bank-transfer-logo"
        />
        <Icon
          :name="paymentType === 1 ? 'radio-selected-f' : 'checkbox-unselect-f'"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { Icon } from '@/components/Icon'
import { Skeleton } from '@/components/Skeleton'
import { useOrder } from '@/views/Carts/hooks/useOrder'
import { useCart } from '@/views/Carts/hooks/useCart'

const { loading, isAllEmpty } = useCart()
const { paymentType, totalAmountAfterDiscount } = useOrder()

const onPayPalClick = () => {
  if (totalAmountAfterDiscount.value > 500) return
  paymentType.value = 0
}
</script>

<style lang="less" scoped>
.express-checkout {
  margin-bottom: 12px;
  padding: 16px 12px;
  border-radius: 8px;
  background-color: #FFFFFF;

  &__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  &__title {
    font-family: mon-700;
    font-size: 14px;
    line-height: 18px;
  }

  &__secure {
    display: flex;
    align-items: center;
    gap: 2px;
    font-family: mon-500;
    font-size: 11px;
    line-height: 14px;
    color: #168A73;
  }

  &__icon {
    font-size: 14px;
  }

  &__content {
    margin-top: 16px;
    display: flex;
    gap: 13px;
  }

  &-paypal, &-bank {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 10px 12px;
    border-radius: 6px;
    border: 1px solid #EBF1F5;
  }

  &-paypal {
    &__logo {
      width: 74px;
      height: 20px;
    }

    &--disabled {
      filter: grayscale(1) opacity(.5);
    }
  }

  &-bank {
    &__logo {
      width: 71px;
      height: 20px;
    }
  }

  &-paypal--selected {
    border-color: #FFD100;
    background-color: #FFD100;
  }

  &-bank--selected {
    color: #FFFFFF;
    border-color: #232323;
    background-color: #232323;
  }
}
</style>
